
























































































import {
  Component,
  Prop,
  Model,
  Watch,
  Vue as VueDecorator,
} from "vue-property-decorator";

import { UserModule } from "@/store/modules/UserModule";
import { getUserDisplayNameAndRole } from "@/utils/UserUtils";
import User from "@/data/models/User";
import { findUser } from "@/data/repository/UserRepository";
import SearchFieldComponent from "@/components/common/SearchField.vue";

/** Show the search field only once the list is long enough to warrant it. */
const SEARCH_THRESHOLD = 8;

@Component({
  components: {
    "search-field": SearchFieldComponent,
  },
})
export default class UserPickerComponent extends VueDecorator {
  isPickerOpen = false;

  @Model("change") userId!: string | null;
  @Prop() label!: string;
  @Prop({ default: false }) readonly!: boolean;
  @Prop({ default: false }) onlyShowNickname!: boolean;
  @Prop({ default: false }) hideDetails!: boolean;
  @Prop({ default: () => UserModule.usersForSelection })
  usersForSelection!: User[];
  @Prop() projectBranch!: string | null;

  @Prop({ default: false }) showClearInputOption!: boolean;
  @Prop({ default: () => [] }) errors!: string[];

  get showClearInputIcon() {
    return this.showClearInputOption && !!this.userId;
  }

  get selectedUser() {
    return findUser(this.userId);
  }

  get selectedString() {
    return this.onlyShowNickname ? this.selectedUser?.nickname : getUserDisplayNameAndRole(this.selectedUser, this);
  }

  get filteredUsersForSelection() {

    if (this.projectBranch && this.projectBranch !== null) {
      return this.usersForSelection.filter(
        (user: User) =>
          user.branches?.length === 0 ||
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          user.branches?.includes(this.projectBranch!!)
        );
    }

    return this.usersForSelection;    
  }

  searchQuery = "";

  get showSearch() {
    return this.filteredUsersForSelection.length > SEARCH_THRESHOLD;
  }

  get searchedUsersForSelection() {
    const query = this.searchQuery.toLowerCase().trim();

    if (query === "") {
      return this.filteredUsersForSelection;
    }

    return this.filteredUsersForSelection.filter(
      (user) => this.getUserName(user).toLowerCase().indexOf(query) >= 0
    );
  }

  onSearchQueryChanged(searchQuery: string) {
    this.searchQuery = searchQuery;
  }

  @Watch("isPickerOpen")
  onPickerOpenChanged(isOpen: boolean) {
    if (isOpen) {
      this.searchQuery = "";
    }
  }

  getUserName(user: User | null) {
    return getUserDisplayNameAndRole(user, this);
  }

  onBack() {
    this.isPickerOpen = false;
  }

  onNoSelection() {
    this.onSelectedChanged(null);
  }

  onUserSelected(item: User) {
    this.onSelectedChanged(item.id);
  }

  onSelectedChanged(userId: string | null) {
    this.isPickerOpen = false;
    this.$emit("change", userId);
    this.$emit("selectedUserChanged", this.selectedUser);
  }

  onClearInput() {
    this.onSelectedChanged(null);
  }
}
